import { Section, SpacedElements } from '@elfsight/lib-stripe-integration';
import { useLingui } from '@lingui/react/macro';
import { Title } from './title';

export function PaymentFormTitleBlock() {
  const { t } = useLingui();

  return (
    <Section $classModifier="form-title">
      <SpacedElements>
        <Title>{t`Payment`}</Title>
      </SpacedElements>
    </Section>
  );
}
